import { FormItem } from "../../../../../../commons/Form/Form.types";
import { AddSubUserFormSchema } from "./AddSubUserENTForm.types";

export const addSubUserFormData: FormItem<AddSubUserFormSchema>[][] = [
  [
    {
      name: 'firstName',
      placeholder: 'Votre prénom...',
      label: 'Prénom',
      type: 'text',
      required: true
    },
    {
      name: 'lastName',
      placeholder: 'Votre nom...',
      label: 'Nom',
      type: 'text',
      required: true
    }
  ],
  [
    {
      name: 'email',
      placeholder: 'Votre adresse email...',
      label: 'Adresse email',
      type: 'text',
      required: true,
      autoComplete: 'nope'
    },
    // {
    //   name: 'password',
    //   placeholder: 'Votre mot de passe...',
    //   label: 'Mot de passe',
    //   type: 'password',
    //   required: true,
    //   autoComplete: 'nope'
    // }
  ]
  // [
  //   {
  //     name: 'rights',
  //     label: 'Niveau de droits',
  //     type: 'select',
  //     options: Object.keys(pagesSupeviseursList).map(key => ({
  //       value: key,
  //       label: key
  //     })),
  //     required: true,
  //     // @ts-ignore
  //     isMulti: true
  //   }
  // ]
  // [
  //   {
  //     name: 'rights',
  //     label: 'Niveau de droits',
  //     type: 'select',
  //     defaultValue: {
  //       // @ts-ignore
  //       value: '1',
  //       label: 'Défaut'
  //     },
  //     options: [
  //       {
  //         value: '1',
  //         label: 'Défaut'
  //       }
  //     ],
  //     required: true,
  //     disabled: true
  //   }
  // ]
]